//New Application
// import Login from "../views/login/Login";
// import HomePage from "../views/homepage/HomePage";
// import VerifyEmail from "../views/NewApplication/VerifyEmail";
// import VerifyOtp from "../views/NewApplication/VerifyOtp";
// import ApplicantsDetails from "../views/NewApplication/ApplicantsDetails";
// import ProofOfTrust from "../views/NewApplication/ProofOfTrust";
// import ApplicantsIdentification from "../views/NewApplication/ApplicantsIdentification";
// import CoBorrowersDetails from "../views/NewApplication/Co-BorrowersDetails";
// import IdentificationOfCoBorrower from "../views/NewApplication/IdentificationOfCo_Borrower ";
// import ApplicantProfessionalDetails from "../views/NewApplication/ApplicantProfessionalDetails";
// import UploadDocumentsOne from "../views/NewApplication/UploadDocuments1";
//import UploadDocumentsTwo from "../views/NewApplication/UploadDocuments2";
//import UploadDocumentsThree from "../views/NewApplication/UploadDocuments3";
// import Liquidity from "../views/NewApplication/Liquidity";
// import RealEstateAssets from "../views/NewApplication/RealEstateAssets";

// import BusinessAssets from "../views/NewApplication/BusinessAssets";
// import PartnershipInterests from "../views/NewApplication/PartnershipInterests";
// import PersonalHolding from "../views/NewApplication/PersonalHolding";
// import LiabilitiesForm from "../views/NewApplication/Liabilities";
// import IncomeSources from "../views/NewApplication/IncomeSources";
// import Expenses from "../views/NewApplication/Expenses";
// import Dashboard from "../views/NewApplication/Dashboard";

// import BalanceSheetTotalAssets from "../views/NewApplication/BalanceSheetTotalAssets";
// import Questionnaire from "../views/NewApplication/BalanceSheetQuestionnaire";
// import BalanceSheetAssets from "../views/NewApplication/BalanceSheetAssets";
// import BalanceSheetTotalLiabilities from "../views/NewApplication/BalanceSheetTotalLiabilities";

//User Account
// import RegisteredEmail from "../views/UserAccount/RegisteredEmail";
// import RegisteredEmailOtp from "../views/UserAccount/RegisteredEmailOtp";

//Application Status
// import ApplicationStatus from "../views/ApplicationStatus/ApplicationStatus";

//Banker UI
// import LoanApplications from "../views/BankerUI/LoanApplications";
// import RevisionRequest from "../views/BankerUI/RevisionRequest";
// import BankerDashboard from "../views/BankerUI/BankerDashboard";
// import Sponsors from "../views/BankerUI/Sponsors";
// import MyApplications from "../views/UserAccount/MyApplications";
// import EnterEmail from "../views/BankerUI/EnterEmail";
// import AccountLogin from "../views/BankerUI/AccountLogin";
//import RecoveryDetails from "../views/BankerUI/RecoveryDetails";
// import ForgottenPassword from "../views/BankerUI/ForgottenPassword";
// import ForgotUserLoginPassword from "../views/NewApplication/ForgotUserLoginPassword";
// import VerifyEmailOtp from "../views/BankerUI/VerifyEmailOtp";
// import PersonalDetails from "../views/BankerUI/PersonalDetails";
// import ProfessionalDetails from "../views/BankerUI/ProfessionalDetails";
// import CreateNewPasswordForBanker from "../views/BankerUI/CreateNewPasswordForBanker";
// import ApplicantUnderwritingCriteria from "../views/BankerUI/ApplicantUnderwritingCriteria";
// import BankerProfile from "../views/BankerUI/BankerProfile";
// import AddEditSponsers from "../views/BankerUI/AddEditSponsers";
// import LoanApplicationDetails from "../views/BankerUI/LoanApplicationDetails";

// import LiveAccountBalancesForBanker from "../views/BankerUI/LiveAccountBalancesForBanker";
// import AdvancesAndRepaymentsForBanker from "../views/BankerUI/AdvancesAndRepaymentsForBanker";
// import DataInsightsForBanker from "../views/BankerUI/DataInsightsForBanker";

//Loan Officer UI
// import EnterEmailForLoanOfficer from "../views/LoanOfficerUI/EnterEmailForLoanOfficer";
// import AccountLoginForLoanOfficer from "../views/LoanOfficerUI/AccountLoginForLoanOfficer";
//import RecoveryDetailsForLoanOfficer from "../views/LoanOfficerUI/RecoveryDetails"
// import VerifyEmailOtpForLoanOfficer from "../views/LoanOfficerUI/VerifyEmailOtpForLoanOfficer";
// import PersonalDetailsForLoanOfficer from "../views/LoanOfficerUI/PersonalDetailsForLoanOfficer";
// import ProfessionalDetailsForLoanOfficer from "../views/LoanOfficerUI/ProfessionalDetailsForLoanOfficer";
// import CreateNewPasswordForLoanOfficer from "../views/LoanOfficerUI/CreateNewPasswordForLoanOfficer";
// import ForgotLoanOfficerPassword from "../views/LoanOfficerUI/ForgotLoanOfficerPassword";
// import LoanOfficerDashboard from "../views/LoanOfficerUI/LoanOfficerDashboard";
// import LoanOfficerRevisionRequest from "../views/LoanOfficerUI/LoanOfficerRevisionRequest";
// import LoanOfficerProfile from "../views/LoanOfficerUI/LoanOfficerProfile";
// import CreateNewPasswordForUser from "../views/NewApplication/CreateNewPasswordForUser";
// import ForgotUserLoginPasswordSendOTP from "../views/NewApplication/ForgotUserLoginPasswordSendOTP";
// import ForgotBankerLoginPasswordSendOTP from "../views/BankerUI/ForgotBankerLoginPasswordSendOTP";
// import ForgotLoanOfficerLoginPasswordSendOTP from "../views/LoanOfficerUI/ForgotLoanOfficerLoginPasswordSendOTP";
// import LoanApplicationsForLoanOfficer from "../views/LoanOfficerUI/LoanApplicationsForLoanOfficer";
// import LiveAccountBalances from "../views/BankerUI/LiveAccountBalances";
// import AdvancesAndRepayments from "../views/BankerUI/AdvancesAndRepayments";
// import DataInsights from "../views/BankerUI/DataInsights";


//bank admin
// import BankAdminLogin from "../views/BankAdmin/BankAdminLogin";
// import CreateBankAdminAccount from "../views/BankAdmin/CreateBankAdminAccount";
// import BankAdminVerifyOtp from "../views/BankAdmin/BankAdminVerifyOtp";
// import BankAdminPersonalDetails from "../views/BankAdmin/BankAdminPersonalDetails";
// import CreateBankAdminPassword from "../views/BankAdmin/CreateBankAdminPassword";
// import BankAdminProfessionalDetails from "../views/BankAdmin/BankAdminProfessionalDetails";
// import BankAdminDashboard from "../views/BankAdmin/BankAdminDashboard";
// import BankAdminProfile from "../views/BankAdmin/BankAdminProfile";
// Firm Admin
// import FirmAdminLogin from "../views/FirmAdmin/FirmAdminLogin";
// import FirmAdminDashboard from "../views/FirmAdmin/FirmAdminDashboard";
// import FirmAdminSponsersDetails from "../views/FirmAdmin/FirmAdminSponsersDetails";
// import LiveAccountBalances from "../views/FirmAdmin/LiveAccountBalancesForFirmAdmin";
// import DataInsights from "../views/FirmAdmin/DataInsightsForFirmAdmin";
// import AdvancesAndRepayments from "../views/FirmAdmin/AdvancesAndRepaymentsForFirmAdmin";

//new project start from here --> Levridgeconsumeruidev
//client
import ConsumerLogin from "../views/ConsumerProject/Consumer/ConsumerLogin";
import CreateConsumerAccount from "../views/ConsumerProject/Consumer/CreateConsumerAccount";
import ConsumerVerifyOtp from "../views/ConsumerProject/Consumer/ConsumerVerifyOtp";
import CreateConsumerLoginPassword from "../views/ConsumerProject/Consumer/CreateConsumerLoginPassword";
import ConsumerPersonalDetails from "../views/ConsumerProject/Consumer/ConsumerPersonalDetails";
import ForgotConsumerLoginPassword from "../views/ConsumerProject/Consumer/ForgotConsumerLoginPassword";
import ForgotConsumerLoginPasswordSendOTP from "../views/ConsumerProject/Consumer/ForgotConsumerLoginPasswordSendOTP";
import ConsumerDashboard from "../views/ConsumerProject/Consumer/ConsumerDashboard";
import ConsumerMarketPlace from "../views/ConsumerProject/Consumer/ConsumerMarketPlace";
import ConsumerInsightsReports from "../views/ConsumerProject/Consumer/InsightsReports";
import ConsumerReports from "../views/ConsumerProject/Consumer/ConsumerReports";
import ConsumerProfile from "../views/ConsumerProject/Consumer/ConsumerProfile";
import NewLiquidityApplication from "../views/ConsumerProject/Consumer/NewLiquidityApplication";
import DocumentsUpload from "../views/ConsumerProject/Consumer/ConsumerDocumentsUpload";
import ConsumerDetailsDashboard from "../views/ConsumerProject/Consumer/ConsumerDetailsDashboard";
import IncomeSourcesForConsumer from "../views/ConsumerProject/Consumer/IncomeSourcesForConsumer";
import ExpensesForConsumer from "../views/ConsumerProject/Consumer/ExpensesForConsumer";
import BalanceSheetAssetsForConsumer from "../views/ConsumerProject/Consumer/BalanceSheetAssetsForConsumer";
import BalanceSheetTotalAssetsForConsumer from "../views/ConsumerProject/Consumer/BalanceSheetTotalAssetsForConsumer";
import BalanceSheetTotalLiabilitiesForConsumer from "../views/ConsumerProject/Consumer/BalanceSheetTotalLiabilitiesForConsumer";
import QuestionnaireForConsumer from "../views/ConsumerProject/Consumer/BalanceSheetQuestionnaireForConsumer";
import FinancialStatementTabForConsumer from "../views/ConsumerProject/Consumer/FinancialStatementTabForConsumer";
import ConsumerUploadDocumentsPreview from "../views/ConsumerProject/Consumer/ConsumerUploadDocumentsPreview";
import ReportPreview from "../views/ConsumerProject/Consumer/ConsumerReportsPreview";
import ApplicationSubmitted from "../views/ConsumerProject/Consumer/ApplicationSubmitted";

//Administrator
import AdministratorLogin from "../views/ConsumerProject/Administrator/AdministratorLogin";
import CreateAdministratorAccount from "../views/ConsumerProject/Administrator/CreateAdministratorAccount";
import AdministratorVerifyOTP from "../views/ConsumerProject/Administrator/AdministratorVerifyOTP";
import CreateAdministratorLoginPassword from "../views/ConsumerProject/Administrator/CreateAdministratorLoginPassword";
import AdministratorPersonalDetails from "../views/ConsumerProject/Administrator/AdministratorPersonalDetails";
import AdministratorProfessionalDetails from "../views/ConsumerProject/Administrator/AdministratorProfessionalDetails";
import AdministratorDashboard from "../views/ConsumerProject/Administrator/AdministratorDashboard";
import ForgotAdministratorLoginPasswordSendOTP from "../views/ConsumerProject/Administrator/ForgotAdministratorLoginPasswordSendOTP";
import ForgotAdministratorLoginPassword from "../views/ConsumerProject/Administrator/ForgotAdministratorLoginPassword";
import AdministratorProfile from "../views/ConsumerProject/Administrator/AdministratorProfile";
// import LoanApplicationsForAdministrator from "../views/ConsumerProject/Administrator/LoanApplicationsForAdministrator";
import SponsorsCapitalProvider from "../views/ConsumerProject/Administrator/SponsorsCapitalProvider";
import AddEditSponsersForAdministrator from "../views/ConsumerProject/Administrator/AddEditSponsersForAdministrator";
import LoanApplicationDetailsForAdministrator from "../views/ConsumerProject/Administrator/LoanApplicationDetailsForAdministrator";
import DataInsightsForAdministrator from "../views/ConsumerProject/Administrator/DataInsightsForAdministrator";
import LoanDetailsHeaderForAdministrator from "../views/ConsumerProject/Administrator/LoanDetailsHeaderForAdministrator";
import AdministratorReports from "../views/ConsumerProject/Administrator/AdministratorReports";

// Capital Provider
import CapitalProviderLogin from "../views/ConsumerProject/CapitalProvider/CapitalProviderLogin";
import CreateCapitalProviderAccount from "../views/ConsumerProject/CapitalProvider/CreateCapitalProviderAccount";
import CapitalProviderVerifyOTP from "../views/ConsumerProject/CapitalProvider/CapitalProviderVerifyOTP";
import CreateCapitalProviderLoginPassword from "../views/ConsumerProject/CapitalProvider/CreateCapitalProviderLoginPassword";
import CapitalProviderPersonalDetails from "../views/ConsumerProject/CapitalProvider/CapitalProviderPersonalDetails";
import CapitalProviderDashboard from "../views/ConsumerProject/CapitalProvider/CapitalProviderDashboard";
import ForgotCapitalProviderLoginPasswordSendOTP from "../views/ConsumerProject/CapitalProvider/ForgotCapitalProviderLoginPasswordSendOTP";
import ForgotCapitalProviderLoginPassword from "../views/ConsumerProject/CapitalProvider/ForgotCapitalProviderLoginPassword";
import CapitalProviderProfile from "../views/ConsumerProject/CapitalProvider/CapitalProviderProfile";
import CapitalProviderProfessionalDetails from "../views/ConsumerProject/CapitalProvider/CapitalProviderProfessionalDetails";
// import LoanApplicationsForCapitalProvider from "../views/ConsumerProject/CapitalProvider/LoanApplicationsForCapitalProvider";
import DataInsightsForCapitalProvider from "../views/ConsumerProject/CapitalProvider/DataInsightsForCapitalProvider";
import CapitalProviderReports from "../views/ConsumerProject/CapitalProvider/CapitalProviderReports";
import ConsumerSecondaryMarketDetail from "../views/ConsumerProject/Consumer/ConsumerSecondaryMarketDetail";

export const routes = {
    login: {
        path: "/login",
        basePath: "/login",
        name: "ConsumerLogin",
        component: ConsumerLogin,
    },
    registeredEmail: {
        path: "/",
        basePath: "/",
        name: "ConsumerLogin",
        component: ConsumerLogin,
    },
    createConsumerAccount: {
        path: "/createConsumerAccount",
        basePath: "/createConsumerAccount",
        name: "CreateConsumerAccount",
        component: CreateConsumerAccount,
    },
    consumerVerifyotp: {
        path: "/consumerVerifyOtp",
        basePath: "/consumerVerifyOtp",
        name: "consumerVerifyOtp",
        component: ConsumerVerifyOtp,
    },
    createConsumerLoginPassword: {
        path: "/createConsumerLoginPassword",
        basePath: "/createConsumerLoginPassword",
        name: "CreateConsumerLoginPassword",
        component: CreateConsumerLoginPassword,
    },
    consumerPersonalDetails: {
        path: "/consumerPersonalDetails",
        basePath: "/consumerPersonalDetails",
        name: "ConsumerPersonalDetails",
        component: ConsumerPersonalDetails,
    },
    forgotConsumerLoginPassword: {
        path: "/forgotConsumerLoginPassword",
        basePath: "forgotConsumerLoginPassword",
        name: "ForgotConsumerLoginPassword",
        component: ForgotConsumerLoginPassword,
    },
    forgotConsumerLoginPasswordSendOTP: {
        path: "/forgotConsumerLoginPasswordSendOTP",
        basePath: "/forgotConsumerLoginPasswordSendOTP",
        name: "ForgotConsumerLoginPasswordSendOTP",
        component: ForgotConsumerLoginPasswordSendOTP,
    },
    consumerDashboard: {
        path: "/consumerDashboard",
        basePath: "/consumerDashboard",
        name: "ConsumerDashboard",
        component: ConsumerDashboard,
    },
    consumerMarketPlace: {
        path: "/consumerMarketPlace",
        basePath: "/consumerMarketPlace",
        name: "ConsumerMarketPlace",
        component: ConsumerMarketPlace,
    },
    consumerReports: {
        path: "/consumerReports",
        basePath: "/consumerReports",
        name: "ConsumerReports",
        component: ConsumerReports,
    },
    reportPreview: {
        path: "/reportPreview/:docId",
        basePath: "/reportPreview",
        name: "ReportPreview",
        component: ReportPreview,
    },
    consumerInsightsReports: {
        path: "/consumerInsightsReports",
        basePath: "/consumerInsightsReports",
        name: "ConsumerInsightsReports",
        component: ConsumerInsightsReports,
    },
    consumerProfile: {
        path: "/consumerProfile",
        basePath: "/consumerProfile",
        name: "ConsumerProfile",
        component: ConsumerProfile,
    },
    consumerUploadDocumentsPreview: {
        path: "/consumerUploadDocumentsPreview",
        basePath: "/consumerUploadDocumentsPreview",
        name: "ConsumerUploadDocumentsPreview",
        component: ConsumerUploadDocumentsPreview,
    },
    administratorLogin: {
        path: "/administratorLogin",
        basePath: "/administratorLogin",
        name: "AdministratorLogin",
        component: AdministratorLogin,
    },
    createAdministratorAccount: {
        path: "/createAdministratorAccount",
        basePath: "/createAdministratorAccount",
        name: "CreateAdministratorAccount",
        component: CreateAdministratorAccount,
    },
    administratorVerifyOTP: {
        path: "/administratorVerifyOTP",
        basePath: "/administratorVerifyOTP",
        name: "AdministratorVerifyOTP",
        component: AdministratorVerifyOTP,
    },
    createAdministratorLoginPassword: {
        path: "/createAdministratorLoginPassword",
        basePath: "/createAdministratorLoginPassword",
        name: "CreateAdministratorLoginPassword",
        component: CreateAdministratorLoginPassword,
    },
    administratorPersonalDetails: {
        path: "/administratorPersonalDetails",
        basePath: "/administratorPersonalDetails",
        name: "AdministratorPersonalDetails",
        component: AdministratorPersonalDetails,
    },
    administratorProfessionalDetails: {
        path: "/administratorProfessionalDetails",
        basePath: "/administratorProfessionalDetails",
        name: "AdministratorProfessionalDetails",
        component: AdministratorProfessionalDetails,
    },
    forgotAdministratorLoginPasswordSendOTP: {
        path: "/forgotAdministratorLoginPasswordSendOTP",
        basePath: "/forgotAdministratorLoginPasswordSendOTP",
        name: "ForgotAdministratorLoginPasswordSendOTP",
        component: ForgotAdministratorLoginPasswordSendOTP,
    },
    forgotAdministratorLoginPassword: {
        path: "/forgotAdministratorLoginPassword",
        basePath: "/forgotAdministratorLoginPassword",
        name: "ForgotAdministratorLoginPassword",
        component: ForgotAdministratorLoginPassword,
    },
    administratorProfile: {
        path: "/administratorProfile",
        basePath: "/administratorProfile",
        name: "AdministratorProfile",
        component: AdministratorProfile,
    },
    capitalProviderLogin: {
        path: "/capitalProviderLogin",
        basePath: "/capitalProviderLogin",
        name: "CapitalProviderLogin",
        component: CapitalProviderLogin,
    },
    createCapitalProviderAccount: {
        path: "/createCapitalProviderAccount",
        basePath: "/createCapitalProviderAccount",
        name: "CreateCapitalProviderAccount",
        component: CreateCapitalProviderAccount,
    },
    capitalProviderVerifyOTP: {
        path: "/capitalProviderVerifyOTP",
        basePath: "/capitalProviderVerifyOTP",
        name: "CapitalProviderVerifyOTP",
        component: CapitalProviderVerifyOTP,
    },
    createCapitalProviderLoginPassword: {
        path: "/createCapitalProviderLoginPassword",
        basePath: "/createCapitalProviderLoginPassword",
        name: "CreateCapitalProviderLoginPassword",
        component: CreateCapitalProviderLoginPassword,
    },
    capitalProviderPersonalDetails: {
        path: "/capitalProviderPersonalDetails",
        basePath: "/capitalProviderPersonalDetails",
        name: "CapitalProviderPersonalDetails",
        component: CapitalProviderPersonalDetails,
    },
    capitalProviderProfessionalDetails: {
        path: "/capitalProviderProfessionalDetails",
        basePath: "/capitalProviderProfessionalDetails",
        name: "CapitalProviderProfessionalDetails",
        component: CapitalProviderProfessionalDetails,
    },
    capitalProviderDashboard: {
        path: "/capitalProviderDashboard",
        basePath: "/capitalProviderDashboard",
        name: "CapitalProviderDashboard",
        component: CapitalProviderDashboard,
    },
    forgotCapitalProviderLoginPasswordSendOTP: {
        path: "/forgotCapitalProviderLoginPasswordSendOTP",
        basePath: "/forgotCapitalProviderLoginPasswordSendOTP",
        name: "ForgotCapitalProviderLoginPasswordSendOTP",
        component: ForgotCapitalProviderLoginPasswordSendOTP,
    },
    forgotCapitalProviderLoginPassword: {
        path: "/forgotCapitalProviderLoginPassword",
        basePath: "/forgotCapitalProviderLoginPassword",
        name: "ForgotCapitalProviderLoginPassword",
        component: ForgotCapitalProviderLoginPassword,
    },
    capitalProviderProfile: {
        path: "/capitalProviderProfile",
        basePath: "/capitalProviderProfile",
        name: "CapitalProviderProfile",
        component: CapitalProviderProfile,
    },
    // loanApplicationsForCapitalProvider: {
    //     path: "/loanApplicationsForCapitalProvider",
    //     basePath: "/loanApplicationsForCapitalProvider",
    //     name: "LoanApplicationsForCapitalProvider",
    //     component: LoanApplicationsForCapitalProvider,
    // },
    dataInsightsForCapitalProvider: {
        path: "/dataInsightsForCapitalProvider",
        basePath: "/dataInsightsForCapitalProvider",
        name: "DataInsightsForCapitalProvider",
        component: DataInsightsForCapitalProvider,
    },
    capitalProviderReports: {
        path: "/capitalProviderReports",
        basePath: "/capitalProviderReports",
        name: "CapitalProviderReports",
        component: CapitalProviderReports,
    },
    newLiquidityApplication: {
        path: "/new-liquidity-application",
        basePath: "/new-liquidity-application",
        name: "NewLiquidityApplication",
        component: NewLiquidityApplication,
    },  
    documentsUpload: {
        path: "/documents-upload",
        basePath: "/documents-upload",
        name: "DocumentsUpload",
        component: DocumentsUpload,
    },
    consumerDetailsDashboard: {
        path: "/consumer-details-dashboard",
        basePath: "/consumer-details-dashboard",
        name: "ConsumerDetailsDashboard",
        component: ConsumerDetailsDashboard,
    },
    financialStatementTabForConsumer: {
        path: "/financial-statement-tab-for-consumer",
        basePath: "/financial-statement-tab-for-consumer",
        name: "FinancialStatementTabForConsumer",
        component: FinancialStatementTabForConsumer,
    },
    incomeSourcesForConsumer: {
        path: "/income-sources-consumer",
        basePath: "/income-sources-consumer",
        name: "IncomeSourcesForConsumer",
        component: IncomeSourcesForConsumer,
    },
    expensesForConsumer: {
        path: "/expenses-consumer",
        basePath: "/expenses-consumer",
        name: "ExpensesForConsumer",
        component: ExpensesForConsumer,
    },
    balanceSheetAssetsForConsumer: {
        path: "/balance-sheet-assets-consumer",
        basePath: "/balance-sheet-assets-consumer",
        name: "BalanceSheetAssetsForConsumer",
        component: BalanceSheetAssetsForConsumer,
    },
    balanceSheetTotalAssetsForConsumer: {
        path: "/balance-sheet-total-assets-consumer",
        basePath: "/balance-sheet-total-assets-consumer",
        name: "BalanceSheetTotalAssetsForConsumer",
        component: BalanceSheetTotalAssetsForConsumer,
    },
    balanceSheetTotalLiabilitiesForConsumer: {
        path: "/balance-sheet-total-liabilities-consumer",
        basePath: "/balance-sheet-total-liabilities-consumer",
        name: "BalanceSheetTotalLiabilitiesForConsumer",
        component: BalanceSheetTotalLiabilitiesForConsumer,
    },
    questionnaireForConsumer: {
        path: "/questionnaire-consumer",
        basePath: "/questionnaire-consumer",
        name: "QuestionnaireForConsumer",
        component: QuestionnaireForConsumer,
    },
    administratorDashboard: {
        path: "/administrator-dashboard",
        basePath: "/administrator-dashboard",
        name: "AdministratorDashboard",
        component: AdministratorDashboard,
    },
    // loanApplicationsForAdministrator: {
    //     path: "/loanApplicationsForAdministrator",
    //     basePath: "/loanApplicationsForAdministrator",
    //     name: "LoanApplicationsForAdministrator",
    //     component: LoanApplicationsForAdministrator,
    // },
    sponsorsCapitalProvider: {
        path: "/Sponsors-capital-provider",
        basePath: "/Sponsors-capital-provider",
        name: "SponsorsCapitalProvider",
        component: SponsorsCapitalProvider,
    },
    dataInsightsForAdministrator: {
        path: "/data-insights-for-administrator",
        basePath: "/data-insights-for-administrator",
        name: "DataInsightsForAdministrator",
        component: DataInsightsForAdministrator,
    },
    administratorReports: {
        path: "/administratorReports",
        basePath: "/administratorReports",
        name: "AdministratorReports",
        component: AdministratorReports,
    },
    addEditSponsersForAdministrator: {
        path: "/add-edit-sponsers-for-administrator",
        basePath: "/add-edit-sponsers-for-administrator",
        name: "AddEditSponsersForAdministrator",
        component: AddEditSponsersForAdministrator,
    },
    loanApplicationDetailsForAdministrator: {
        path: "/loanapplication-details-for-administrator/:Id",
        basePath: "/loanapplication-details-for-administrator",
        name: "LoanApplicationDetailsForAdministrator",
        component: LoanApplicationDetailsForAdministrator,
    },
    loanDetailsHeaderForAdministrator: {
        path: "/loan-details-header-for-administrator/:Id",
        basePath: "/loan-details-header-for-administrator",
        name: "LoanDetailsHeaderForAdministrator",
        component: LoanDetailsHeaderForAdministrator,
    },
     consumerSecondaryMarketPlaceDetails: {
        path: "/secondaryMarketDetail",
        basePath: "/secondaryMarketDetail",
        name: "secondaryMarketDetail",
        component: ConsumerSecondaryMarketDetail,
    },
    applicationSubmitted: {
        path: "/applicationSubmitted",
        basePath: "/applicationSubmitted",
        name: "ApplicationSubmitted",
        component: ApplicationSubmitted,
    },
    // homePage: {
    //     path: "/homepage",
    //     basePath: "/homepage",
    //     name: "HomePage",
    //     component: HomePage,
    // },
    // verifyEmail: {
    //     path: "/createaccount",
    //     basePath: "/createaccount",
    //     name: "VerifyEmail",
    //     component: VerifyEmail,
    // },
    // newHomePage: {
    //     path: "/",
    //     basePath: "/",
    //     name: "VerifyOtp",
    //     component: VerifyOtp,
    // },
    // VerifyOtp: {
    //     path: "/verifyotp",
    //     basePath: "/verifyotp",
    //     name: "VerifyOtp",
    //     component: VerifyOtp,
    // },
    // ApplicantsDetails: {
    //     path: "/applicant-details",
    //     basePath: "/applicant-details",
    //     name: "ApplicantDetails",
    //     component: ApplicantsDetails,
    // },
    // ProofOfTrust: {
    //     path: "/proof-of-trust",
    //     basePath: "/proof-of-trust",
    //     name: "ProofOfTrust",
    //     component: ProofOfTrust,
    // },
    // applicantsIdentification: {
    //     path: "/applicant-identification",
    //     basePath: "/applicant-identification",
    //     name: "applicantsIdentification",
    //     component: ApplicantsIdentification,
    // },
    // coBorrowersDetails: {
    //     path: "/co-BorrowersDetails",
    //     basePath: "/co-BorrowersDetails",
    //     name: "co-BorrowersDetails",
    //     component: CoBorrowersDetails,
    // },
    // identificationOfcoBorrower: {
    //     path: "/identificationOfCo-Borrower",
    //     basePath: "/identificationOfCo-Borrower",
    //     name: "identificationOfCo-Borrower",
    //     component: IdentificationOfCoBorrower,
    // },
    // applicantProfessionalDetails: {
    //     path: "/applicantProfessionalDetails",
    //     basePath: "/applicantProfessionalDetails",
    //     name: "applicantProfessionalDetails",
    //     component: ApplicantProfessionalDetails,
    // },
    // uploaddocuments: {
    //     path: "/upload-documents",
    //     basePath: "/upload-documents",
    //     name: "UploadDocuments",
    //     component: UploadDocumentsOne,
    // },
    // liquidity: {
    //     path: "/liquidity",
    //     basePath: "/liquidity",
    //     name: "liquidity",
    //     component: Liquidity,
    // },
    // realestateassets: {
    //     path: "/real-estate-assets",
    //     basePath: "/real-estate-assets",
    //     name: "RealEstateAssets",
    //     component: RealEstateAssets,
    // },
    // businessAssets: {
    //     path: "/business-assets",
    //     basePath: "/business-assets",
    //     name: "businessAssets",
    //     component: BusinessAssets,
    // },
    // partnershipInterests: {
    //     path: "/partnership-interests",
    //     basePath: "/partnership-interests",
    //     name: "partnershipInterests",
    //     component: PartnershipInterests,
    // },
    // personalHolding: {
    //     path: "/personal-holding",
    //     basePath: "/personal-holding",
    //     name: "personalHolding",
    //     component: PersonalHolding,
    // },
    // liabilitiesForm: {
    //     path: "/liabilities",
    //     basePath: "/liabilities",
    //     name: "liabilities",
    //     component: LiabilitiesForm,
    // },
    // incomeSources: {
    //     path: "/income-sources",
    //     basePath: "/income-sources",
    //     name: "incomeSources",
    //     component: IncomeSources,
    // },
    // expenses: {
    //     path: "/expenses",
    //     basePath: "/expenses",
    //     name: "expenses",
    //     component: Expenses,
    // },
    // balanceSheetAssets: {
    //     path: "/balance-sheet-assets",
    //     basePath: "/balance-sheet-assets",
    //     name: "balancesheetassets",
    //     component: BalanceSheetAssets,
    // },
    // balanceSheetTotalAssets: {
    //     path: "/balance-sheet-total-assets",
    //     basePath: "/balance-sheet-total-assets",
    //     name: "balanceSheetTotalAssets",
    //     component: BalanceSheetTotalAssets,
    // },
    // balanceSheetTotalLiabilities: {
    //     path: "/balance-sheet-total-liabilities",
    //     basePath: "/balance-sheet-total-liabilities",
    //     name: "/BalanceSheetTotalLiabilities",
    //     component: BalanceSheetTotalLiabilities,
    // },
    // questionnaire: {
    //     path: "/questionnaire",
    //     basePath: "/questionnaire",
    //     name: "/questionnaire",
    //     component: Questionnaire,
    // },
    // dashboard: {
    //     path: "/dashboard",
    //     basePath: "/dashboard",
    //     name: "Dashboard",
    //     component: Dashboard,
    // },
    // registeredEmailOtp: {
    //     path: "/userlogin-otp",
    //     basePath: "/userlogin-otp",
    //     name: "registeredEmailOtp",
    //     component: RegisteredEmailOtp,
    // },
    // createNewPasswordForUser: {
    //     path: "/createNewPasswordForUser",
    //     basePath: "/createNewPasswordForUser",
    //     name: "createNewPasswordForUser",
    //     component: CreateNewPasswordForUser,
    // },
    // myApplications: {
    //     path: "/my-applications",
    //     basePath: "/my-applications",
    //     name: "MyApplications",
    //     component: MyApplications,
    // },
    // applicationStatus: {
    //     path: "/applicationstatus",
    //     basePath: "/applicationstatus",
    //     name: "applicationStatus",
    //     component: ApplicationStatus,
    // },
    // bankerdashboard: {
    //     path: "/banker-dashboard",
    //     basePath: "/banker-dashboard",
    //     name: "BankerDashboard",
    //     component: BankerDashboard,
    // },
    // bankerprofile: {
    //     path: "/banker-profile",
    //     basePath: "/banker-profile",
    //     name: "BankerProfile",
    //     component: BankerProfile,
    // },
    // applicantUnderwritingCriteria: {
    //     path: "/applicantUnderwritingCriteria",
    //     basePath: "/applicantUnderwritingCriteria",
    //     name: "ApplicantUnderwritingCriteria",
    //     component: ApplicantUnderwritingCriteria,
    // },
    // loanapplication: {
    //     path: "/loan-application",
    //     basePath: "/loan-application",
    //     name: "LoanApplication",
    //     component: LoanApplications,
    // },
    // revisionrequest: {
    //     path: "/revision-request",
    //     basePath: "/revision-request",
    //     name: "RevisionRequest",
    //     component: RevisionRequest,
    // },
    // sponsors: {
    //     path: "/sponsors",
    //     basePath: "/sponsors",
    //     name: "Sponsors",
    //     component: Sponsors,
    // },
    // addEditSponsers: {
    //     path: "/add-edit-sponsers",
    //     basePath: "/add-edit-sponsers",
    //     name: "AddEditSponsers",
    //     component: AddEditSponsers,
    // },
    // enterEmail: {
    //     path: "/createbankeraccount",
    //     basePath: "/createbankeraccount",
    //     name: "enterEmail",
    //     component: EnterEmail,
    // },
    // verifyEmailOtp: {
    //     path: "/verify-email-otp",
    //     basePath: "/verify-email-otp",
    //     name: "verifyEmailOtp",
    //     component: VerifyEmailOtp,
    // },
    // accountLogin: {
    //     path: "/bankerlogin",
    //     basePath: "/bankerlogin",
    //     name: "accountLogin",
    //     component: AccountLogin,
    // },
    // forgotUserLoginPassword: {
    //     path: "/forgotUserLoginPassword",
    //     basePath: "forgotUserLoginPassword",
    //     name: "ForgotUserLoginPassword",
    //     component: ForgotUserLoginPassword,
    // },
    // ForgottenPassword: {
    //     path: "/forgottenPassword",
    //     basePath: "forgottenPassword",
    //     name: "ForgottenPassword",
    //     component: ForgottenPassword,
    // },
    // personalDetails: {
    //     path: "/personal-details",
    //     basePath: "/personal-details",
    //     name: "personalDetails",
    //     component: PersonalDetails,
    // },
    // professionalDetails: {
    //     path: "/professional-details",
    //     basePath: "/professional-details",
    //     name: "professionalDetails",
    //     component: ProfessionalDetails,
    // },
    // createNewPasswordForBanker: {
    //     path: "/createNewPasswordForBanker",
    //     basePath: "/createNewPasswordForBanker",
    //     name: "createNewPasswordForBanker",
    //     component: CreateNewPasswordForBanker,
    // },
    // enterEmailForLoanOfficer: {
    //     path: "/createloanofficeraccount",
    //     basePath: "/createloanofficeraccount",
    //     name: "enterEmailForLoanOfficer",
    //     component: EnterEmailForLoanOfficer,
    // },
    // verifyEmailOtpForLoanOfficer: {
    //     path: "/verifyEmailOtpForLoanOfficer",
    //     basePath: "/verifyEmailOtpForLoanOfficer",
    //     name: "verifyEmailOtpForLoanOfficer",
    //     component: VerifyEmailOtpForLoanOfficer,
    // },
    // accountLoginForLoanOfficer: {
    //     path: "/loanofficerlogin",
    //     basePath: "/loanofficerlogin",
    //     name: "accountLoginForLoanOfficer",
    //     component: AccountLoginForLoanOfficer,
    // },
    // forgotLoanOfficerPassword: {
    //     path: "/forgotLoanOfficerPassword",
    //     basePath: "/forgotLoanOfficerPassword",
    //     name: "forgotLoanOfficerPassword",
    //     component: ForgotLoanOfficerPassword,
    // },
    // personalDetailsForLoanOfficer: {
    //     path: "/personalDetailsForLoanOfficer",
    //     basePath: "/personalDetailsForLoanOfficer",
    //     name: "personalDetailsForLoanOfficer",
    //     component: PersonalDetailsForLoanOfficer,
    // },
    // professionalDetailsForLoanOfficer: {
    //     path: "/professionalDetailsForLoanOfficer",
    //     basePath: "/professionalDetailsForLoanOfficer",
    //     name: "professionalDetailsForLoanOfficer",
    //     component: ProfessionalDetailsForLoanOfficer,
    // },
    // createNewPasswordForLoanOfficer: {
    //     path: "/createNewPasswordForLoanOfficer",
    //     basePath: "/createNewPasswordForLoanOfficer",
    //     name: "createNewPasswordForLoanOfficer",
    //     component: CreateNewPasswordForLoanOfficer,
    // },
    // loanApplicationDetails: {
    //     path: "/loanApplicationDetails/:Id",
    //     basePath: "/loanApplicationDetails",
    //     name: "loanApplicationDetails",
    //     component: LoanApplicationDetails,
    // },
    // loanOfficerDashboard: {
    //     path: "/loanOfficerDashboard",
    //     basePath: "/loanOfficerDashboard",
    //     name: "LoanOfficerDashboard",
    //     component: LoanOfficerDashboard,
    // },
    // loanOfficerRevisionRequest: {
    //     path: "/loanOfficerRevisionRequest",
    //     basePath: "/loanOfficerRevisionRequest",
    //     name: "LoanOfficerRevisionRequest",
    //     component: LoanOfficerRevisionRequest,
    // },
    // loanOfficerProfile: {
    //     path: "/loan-Officer-profile",
    //     basePath: "/loan-Officer-profile",
    //     name: "LoanOfficerProfile",
    //     component: LoanOfficerProfile,
    // },
    // forgotUserLoginPasswordSendOTP: {
    //     path: "/forgotUserLoginPasswordSendOTP",
    //     basePath: "/forgotUserLoginPasswordSendOTP",
    //     name: "ForgotUserLoginPasswordSendOTP",
    //     component: ForgotUserLoginPasswordSendOTP,
    // },
    // forgotBankerLoginPasswordSendOTP: {
    //     path: "/forgotBankerLoginPasswordSendOTP",
    //     basePath: "/forgotBankerLoginPasswordSendOTP",
    //     name: "ForgotBankerLoginPasswordSendOTP",
    //     component: ForgotBankerLoginPasswordSendOTP,
    // },
    // forgotLoanOfficerLoginPasswordSendOTP: {
    //     path: "/forgotLoanOfficerLoginPasswordSendOTP",
    //     basePath: "/forgotLoanOfficerLoginPasswordSendOTP",
    //     name: "ForgotLoanOfficerLoginPasswordSendOTP",
    //     component: ForgotLoanOfficerLoginPasswordSendOTP,
    // },
    // loanApplicationsForLoanOfficer: {
    //     path: "/loanApplicationsForLoanOfficer",
    //     basePath: "/loanApplicationsForLoanOfficer",
    //     name: "LoanApplicationsForLoanOfficer",
    //     component: LoanApplicationsForLoanOfficer,
    // },
    // liveAccountBalances: {
    //     path: "/liveAccountBalances",
    //     basePath: "/liveAccountBalances",
    //     name: "LiveAccountBalances",
    //     component: LiveAccountBalances,
    // },
    // advancesAndRepayments: {
    //     path: "/advancesAndRepayments",
    //     basePath: "/advancesAndRepayments",
    //     name: "AdvancesAndRepayments",
    //     component: AdvancesAndRepayments,
    // },
    // dataInsights: {
    //     path: "/dataInsights",
    //     basePath: "/dataInsights",
    //     name: "DataInsights",
    //     component: DataInsights,
    // },
    // bankAdminLogin: {
    //     path: "/bankadminlogin",
    //     basePath: "/bankAdminLogin",
    //     name: "BankAdminLogin",
    //     component: BankAdminLogin,
    // },
    // createBankAdminAccount: {
    //     path: "/createbankadminaccount",
    //     basePath: "/createBankAdminAccount",
    //     name: "CreateBankAdminAccount",
    //     component: CreateBankAdminAccount,
    // },
    // bankadminverifyotp: {
    //     path: "/bankadminverifyotp",
    //     basePath: "/bankadminverifyotp",
    //     name: "BankAdminVerifyOtp",
    //     component: BankAdminVerifyOtp,
    // },
    // bankadminpersonaldetails: {
    //     path: "/bankadminpersonaldetails",
    //     basePath: "/bankadminpersonaldetails",
    //     name: "BankAdminPersonalDetails",
    //     component: BankAdminPersonalDetails,
    // },
    // bankadminprofessionaldetails: {
    //     path: "/bankadminprofessionaldetails",
    //     basePath: "/bankadminprofessionaldetails",
    //     name: "BankAdminProfessionalDetails",
    //     component: BankAdminProfessionalDetails,
    // },
    // createbankadminpassword: {
    //     path: "/createbankadminpassword",
    //     basePath: "/createbankadminpassword",
    //     name: "CreateBankAdminPassword",
    //     component: CreateBankAdminPassword,
    // },
    // bankadmindashboard: {
    //     path: "/bankadmindashboard",
    //     basePath: "/bankadmindashboard",
    //     name: "BankAdminDashboard",
    //     component: BankAdminDashboard,
    // },
    // firmadminlogin: {
    //     path: "/firmadminlogin",
    //     basePath: "/firmadminlogin",
    //     name: "FirmAdminLogin",
    //     component: FirmAdminLogin,
    // },
    // firmadmindashboard: {
    //     path: "/firmadmindashboard",
    //     basePath: "/firmadmindashboard",
    //     name: "FirmAdminDashboard",
    //     component: FirmAdminDashboard,
    // },
    // bankadminprofile: {
    //     path: "/bankadminprofile",
    //     basePath: "/bankadminprofile",
    //     name: "BankAdminProfile",
    //     component: BankAdminProfile,
    // },
    // firmadminsponsersdetails: {
    //     path: "/firmadminsponsersdetails",
    //     basePath: "/firmadminsponsersdetails",
    //     name: "FirmAdminSponsersDetails",
    //     component: FirmAdminSponsersDetails,
    // },
    //  liveAccountBalancesForBanker: {
    //     path: "/liveAccountBalancesForBanker",
    //     basePath: "/liveAccountBalancesForBanker",
    //     name: "LiveAccountBalancesForBanker",
    //     component: LiveAccountBalancesForBanker,
    // },
    // advancesAndRepaymentsForBanker: {
    //     path: "/advancesAndRepaymentsForBanker",
    //     basePath: "/advancesAndRepaymentsForBanker",
    //     name: "AdvancesAndRepaymentsForBanker",
    //     component: AdvancesAndRepaymentsForBanker,
    // },
    // dataInsightsForBanker: {
    //     path: "/dataInsightsForBanker",
    //     basePath: "/dataInsightsForBanker",
    //     name: "DataInsightsForBanker",
    //     component: DataInsightsForBanker,
    // },

    // liveAccountBalancesForBanker: {
    //     path: "/live-account-balances-for-banker",
    //     basePath: "/live-account-balances-for-banker",
    //     name: "LiveAccountBalancesForBanker",
    //     component: LiveAccountBalancesForBanker,
    // },
    // advancesAndRepaymentsForBanker: {
    //     path: "/advances-and-repayments-for-banker",
    //     basePath: "/advances-and-repayments-for-banker",
    //     name: "AdvancesAndRepaymentsForBanker",
    //     component: AdvancesAndRepaymentsForBanker,
    // },
    // dataInsightsForBanker: {
    //     path: "/data-insights-for-banker",
    //     basePath: "/data-insights-for-banker",
    //     name: "DataInsightsForBanker",
    //     component: DataInsightsForBanker,
    // },
};

export const publicRoutes = [
    //Consumer
    routes.login,
    routes.registeredEmail,
    routes.createConsumerAccount,
    routes.consumerVerifyotp,
    routes.forgotConsumerLoginPasswordSendOTP,
    routes.forgotConsumerLoginPassword,

    //Administrator
    routes.administratorLogin,
    routes.createAdministratorAccount,
    routes.administratorVerifyOTP,
    routes.forgotAdministratorLoginPasswordSendOTP,
    routes.forgotAdministratorLoginPassword,

    //Capital Provider
    routes.capitalProviderLogin,
    routes.createCapitalProviderAccount,
    routes.capitalProviderVerifyOTP,
    routes.forgotCapitalProviderLoginPasswordSendOTP,
    routes.forgotCapitalProviderLoginPassword,

    // routes.verifyEmail,
    // routes.VerifyOtp,
    // // routes.newHomePage,   
    // routes.registeredEmailOtp,
    // routes.enterEmail,
    // routes.accountLogin,
    // routes.forgotUserLoginPassword,
    // routes.ForgottenPassword,
    // routes.forgotLoanOfficerPassword,
    // routes.verifyEmailOtp,
    // routes.enterEmailForLoanOfficer,
    // routes.verifyEmailOtpForLoanOfficer,
    // routes.accountLoginForLoanOfficer,
    // routes.applicationStatus,
    // routes.forgotUserLoginPasswordSendOTP,
    // routes.forgotBankerLoginPasswordSendOTP,
    // routes.forgotLoanOfficerLoginPasswordSendOTP,
    // routes.bankAdminLogin,
    // routes.createBankAdminAccount,
    // routes.bankadminverifyotp,
    // routes.firmadminlogin,
    // routes.firmadmindashboard,
];

export const privateRoutes = [
    // routes.homePage,
    // //client flow
    // routes.ApplicantsDetails,
    // routes.ProofOfTrust,
    // routes.applicantsIdentification,
    // routes.coBorrowersDetails,
    // routes.identificationOfcoBorrower,
    // routes.applicantProfessionalDetails,
    // routes.uploaddocuments,
    // routes.liquidity,
    // routes.realestateassets,
    // routes.businessAssets,
    // routes.partnershipInterests,
    // routes.personalHolding,
    // routes.liabilitiesForm,
    // routes.incomeSources,
    // routes.expenses,
    // routes.balanceSheetAssets,
    // routes.balanceSheetTotalAssets,
    // routes.balanceSheetTotalLiabilities,
    // routes.questionnaire,
    // routes.dashboard,
    // routes.myApplications,
    // routes.createNewPasswordForUser,
    // routes.firmadminsponsersdetails,
    // routes.liveAccountBalances,
    // routes.advancesAndRepayments,
    // routes.dataInsights,

    // //banker
    // routes.personalDetails,
    // routes.professionalDetails,
    // routes.loanapplication,
    // routes.revisionrequest,
    // routes.bankerdashboard,
    // routes.bankerprofile,
    // routes.sponsors,
    // routes.addEditSponsers,
    // routes.loanApplicationDetails,
    // routes.createNewPasswordForBanker,
    // routes.liveAccountBalancesForBanker,
    // routes.advancesAndRepaymentsForBanker,
    // routes.dataInsightsForBanker,

    // //loan officer
    // routes.loanOfficerDashboard,
    // routes.loanOfficerRevisionRequest,
    // routes.loanOfficerProfile,
    // routes.loanApplicationsForLoanOfficer,
    // routes.personalDetailsForLoanOfficer,
    // routes.professionalDetailsForLoanOfficer,
    // routes.createNewPasswordForLoanOfficer,

    // //bank admin
    // routes.bankadminpersonaldetails,
    // routes.bankadminprofessionaldetails,
    // routes.createbankadminpassword,
    // routes.bankadmindashboard,
    // routes.bankadminprofile,

    //Consumer
    routes.newLiquidityApplication,
    routes.documentsUpload,
    routes.consumerUploadDocumentsPreview,
    routes.consumerDetailsDashboard,
    routes.financialStatementTabForConsumer,
    routes.incomeSourcesForConsumer,
    routes.expensesForConsumer,
    routes.balanceSheetAssetsForConsumer,
    routes.balanceSheetTotalAssetsForConsumer,
    routes.balanceSheetTotalLiabilitiesForConsumer,
    routes.questionnaireForConsumer,
    routes.consumerDashboard,
    routes.consumerMarketPlace,
    routes.consumerInsightsReports,
    routes.consumerReports,
    routes.reportPreview,
    routes.consumerProfile,
    routes.createConsumerLoginPassword,
    routes.consumerPersonalDetails,
    routes.consumerSecondaryMarketPlaceDetails,
    routes.applicationSubmitted,

    //Administrator
    routes.createAdministratorLoginPassword,
    routes.administratorPersonalDetails,
    routes.administratorProfessionalDetails,
    routes.administratorProfile,
    routes.administratorDashboard,
    routes.sponsorsCapitalProvider,
    // routes.loanApplicationsForAdministrator,
    routes.addEditSponsersForAdministrator,
    routes.loanApplicationDetailsForAdministrator,
    routes.loanDetailsHeaderForAdministrator,
    routes.dataInsightsForAdministrator,
    routes.administratorReports,
    //Capital Provider
    routes.createCapitalProviderLoginPassword,
    routes.capitalProviderPersonalDetails,
    routes.capitalProviderProfessionalDetails,
    routes.capitalProviderDashboard,
    routes.capitalProviderProfile,
    // routes.loanApplicationsForCapitalProvider,
    routes.dataInsightsForCapitalProvider,
    routes.capitalProviderReports
]